
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import 'toastr/build/toastr.min.css';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import pginadeinicio28aeyk from './pages/pginadeinicio28aeyk/pginadeinicio28aeyk'
import sobrenosotrosxe9ue from './pages/sobrenosotrosxe9ue/sobrenosotrosxe9ue'
import inmueblesenventap1coy from './pages/inmueblesenventap1coy/inmueblesenventap1coy'
import inmueblesenrentafeboj from './pages/inmueblesenrentafeboj/inmueblesenrentafeboj'
import visualizacininmuebleqn2py from './pages/visualizacininmuebleqn2py/visualizacininmuebleqn2py'
import contacto1rmwxl from './pages/contacto1rmwxl/contacto1rmwxl'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/" component={pginadeinicio28aeyk} />
			<Route exact path="/sobrenosotros" component={sobrenosotrosxe9ue} />
			<Route exact path="/inmueblesenventa" component={inmueblesenventap1coy} />
			<Route exact path="/inmueblesenrenta" component={inmueblesenrentafeboj} />
			<Route exact path="/visualizacioninmueble/:id" component={visualizacininmuebleqn2py} />
			<Route exact path="/contacto" component={contacto1rmwxl} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

